/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Request_Modal_TitleInputs */

const en_cancel_request_modal_title = /** @type {(inputs: Cancel_Request_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request cancellation`)
};

const ja_cancel_request_modal_title = /** @type {(inputs: Cancel_Request_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル要求`)
};

const fr_cancel_request_modal_title = /** @type {(inputs: Cancel_Request_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander une annulation`)
};

const de_cancel_request_modal_title = /** @type {(inputs: Cancel_Request_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornierung anfordern`)
};

/**
* | output |
* | --- |
* | "Request cancellation" |
*
* @param {Cancel_Request_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cancel_request_modal_title = /** @type {((inputs?: Cancel_Request_Modal_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Request_Modal_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_request_modal_title(inputs)
	if (locale === "ja") return ja_cancel_request_modal_title(inputs)
	if (locale === "fr") return fr_cancel_request_modal_title(inputs)
	return de_cancel_request_modal_title(inputs)
});